<template>
  <div class="c-serviceImageSlide">
    <div
      class="c-serviceImageSlide_paddingHolder"
      :style="{ paddingTop: `${paddingHeight}%` }"
    >
    </div>
    <div
      v-if="isPC && hasStartedSwiperInit"
      class="c-serviceImageSlideInner c-serviceImageSlideInner-slide"
    >
      <div
        v-swiper:mySwiper="swiperOption"
        ref="mySwiper"
        v-if="showSlider"
      >
        <div
          class="swiper-wrapper"
          :class="`swiper-wrapper-${layoutType}`"
        >
          <template v-if="moviePriorityFlag && serviceMovie.length">
            <template v-for="(movie, index) in serviceMovie">
              <movie-wrap
                :movie="movie"
                :box-height="boxHeight"
                :box-width="boxWidth"
                :padding-type="paddingType"
                :padding-ratio="paddingRatio"
                :key="`moviePriority-${index}`"
                :get-type="index ? 'swiper-lazy' : 'swiper-immediate'"
                :swiper-lazy="isSwiperLazy(true, index)"
                @loaded="swiperImageLoaded($event, index)"
              />
            </template>
          </template>

          <template v-if="serviceImage.length">
            <template v-for="(image, index) in serviceImage">
              <div
                class="swiper-slide"
                :key="`image-${index}`"
              >
                <c-service-image
                  :filePath="image.imagePath"
                  :get-type="index ? 'swiper-lazy' : 'swiper-immediate'"
                  class="swiper-lazy"
                  @loaded="swiperImageLoaded($event, index)"
                />
                <div
                  class="swiper-lazy-preloader"
                  v-if="index > 0"
                ></div>
              </div>
            </template>
          </template>

          <template v-if="!moviePriorityFlag && serviceMovie.length">
            <template v-for="(movie, index) in serviceMovie">
              <movie-wrap
                :movie="movie"
                :box-height="boxHeight"
                :box-width="boxWidth"
                :padding-type="paddingType"
                :padding-ratio="paddingRatio"
                :key="`movie-${index}`"
                :get-type="index ? 'swiper-lazy' : 'swiper-immediate'"
                :swiper-lazy="isSwiperLazy(false, index)"
                @loaded="swiperImageLoaded($event, index)"
              />
            </template>
          </template>
        </div>

        <template v-if="numOfImages > 1">
          <span
            class="swiper-button-prev"
            :class="`swiper-button-prev-${layoutType}`"
          >
            <coconala-icon
              name="chevron-left"
              size="13px"
            />
          </span>
          <span
            class="swiper-button-next"
            :class="`swiper-button-next-${layoutType}`"
          >
            <coconala-icon
              name="chevron-right"
              size="13px"
            />
          </span>
        </template>
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="!isPC || !isSwiperLoaded"
        @mouseenter="hasStartedSwiperInit = numOfImages > 1"
        class="c-serviceImageSlideInner c-serviceImageSlideInner-single"
      >
        <service-image
          :service-id="serviceId"
          :service-image="serviceImage"
          :service-movie="serviceMovie"
          :movie-priority-flag="moviePriorityFlag"
          :layout-type="layoutType"
          :box-width="boxWidth"
          :box-height="boxHeight"
          :padding-type="paddingType"
          :padding-ratio="paddingRatio"
          :url-ref="urlRef"
          :disabled-lazy-load="disabledLazyLoad"
        />
      </div>
    </transition>
  </div>
</template>
<script>
// Swiper SSR https://github.com/surmon-china/surmon-china.github.io/tree/source/projects/vue-awesome-swiper/nuxt
import { directive } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'

import CServiceImage from '~/components/atoms/CServiceImage'
import ServiceImage from '~/components/molecules/ServiceImage'
import MovieWrap from './components/MovieWrap'

export default {
  name: 'serviceImageSlide',
  directives: {
    swiper: directive
  },
  components: {
    CServiceImage,
    ServiceImage,
    MovieWrap
  },
  data() {
    return {
      isVideoActive: false,
      showSlider: false,
      hasError: false,
      hasStartedSwiperInit: false,
      isSwiperLoaded: false
    }
  },
  props: {
    serviceId: {
      type: [Number, String],
      default: null
    },
    serviceImage: {
      type: Array,
      default: () => []
    },
    serviceMovie: {
      type: Array,
      default: () => []
    },
    moviePriorityFlag: {
      type: Number,
      default: 0
    },
    layoutType: {
      type: String,
      default: 'List'
    },
    boxWidth: {
      type: [Number, String],
      default: 'auto'
    },
    boxHeight: {
      type: [Number, String],
      default: 'auto'
    },
    paddingType: {
      type: String,
      default: 'ratio'
    },
    // 幅に対する高さの比率
    paddingRatio: {
      type: [Number, String],
      default: 100
    },
    urlRef: {
      type: Object
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabledLazyLoad: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    numOfImages() {
      return this.serviceImage.length + this.serviceMovie.length
    },
    swiperOption() {
      if (this.numOfImages > 1) {
        return {
          loop: true,
          slidesPerView: 1,
          centeredSlides: false,
          lazy: true,
          lazyLoadingOnTransitionStart: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
      return {
        slidesPerView: 1,
        centeredSlides: false,
        lazy: true,
        watchOverflow: true,
        navigation: {}
      }
    },
    paddingHeight() {
      if (this.paddingType === 'ratio') {
        return this.paddingRatio
      }
      if (this.paddingType === 'calc') {
        return (100 * this.boxHeight) / this.boxHeight
      }
      return 0
    }
  },
  watch: {
    // Fetch後の遷移時はisLoadingがtrueになった時点でshowSliderをfalseにし、
    // isLoadingがfalseになった時にshowSliderをtrueにすることでSwiperが再構築される
    // 下記のissueが解決されればもっとスマートな方法ができるかも
    // https://github.com/surmon-china/vue-awesome-swiper/issues/299
    isLoading() {
      if (!this.isLoading) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.showSlider = true
          }, 50)
        })
      } else {
        this.showSlider = false
      }
    }
  },
  methods: {
    isSwiperLazy(moviePriority, indexNum) {
      if (indexNum === 0 && (moviePriority || !this.serviceImage.length)) {
        return false
      }
      return true
    },
    thumbnailUrl(vid) {
      return `https://img.youtube.com/vi/${vid}/hqdefault.jpg`
    },
    swiperImageLoaded(e, index) {
      if (!index) {
        this.isSwiperLoaded = true
      }
    }
  },
  // Fetchの時はisLoadingがfalseなのでshowSliderをtrueにしSwiperを構築する
  created() {
    if (!this.isLoading) {
      this.showSlider = true
    }
  }
}
</script>
<style lang="scss" scoped>
.fade-leave-active {
  transition: opacity 1s;
}

.fade-leave-to {
  opacity: 0;
}

.c-serviceImageSlide {
  position: relative;
}

.c-serviceImageSlideInner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.swiper-container {
  position: relative;

  .swiper-wrapper {
    &-List {
      .swiper-slide {
        img {
          width: 180px;
          height: 150px;
        }

        /* stylelint-disable */
        @media all and (-ms-high-contrast: none) {
          .swiper-lazy-preloader {
            display: none;
          }
        }
        /* stylelint-enable */

        /deep/ .c-vuetube {
          &_thumbnailImage {
            width: 100%;
            height: auto;
          }
        }
      }
    }

    &-Block {
      .swiper-slide {
        img {
          width: 230px;
          height: 188px;
          border-radius: 4px 4px 0 0;
        }

        /* stylelint-disable */
        @media all and (-ms-high-contrast: none) {
          .swiper-lazy-preloader {
            display: none;
          }
        }
        /* stylelint-enable */

        /deep/ .c-vuetube {
          &_thumbnailImage {
            width: 100%;
            height: auto;
          }
        }
      }
    }

    /deep/ .swiper-slide {
      &.thumbnail {
        border-radius: 3px 3px 0 0;
        background-color: $color-black;
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    z-index: 100;
    display: flex;
    width: 16px;
    background: $color-white;
    color: $color-gray-700;
    opacity: 0.9;
    cursor: pointer;

    align-items: center;

    &-List {
      margin-top: -20px;
      height: 40px;
    }

    &-Block {
      margin-top: -25px;
      height: 50px;
    }

    &:hover {
      color: $color-gray-900;
    }

    .coconala-icon {
      line-height: 12px;
    }
  }

  .swiper-button-prev {
    left: -16px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    transition: left 0.2s;
  }

  .swiper-button-next {
    right: -16px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    transition: right 0.2s;

    .coconala-icon {
      padding-left: 2px;
    }
  }

  &:hover {
    .swiper-button-prev {
      left: 0;
    }

    .swiper-button-next {
      right: 0;
    }
  }
}
</style>
